import React from "react";
import { ellipsis, rgba } from "polished";
import Link from "gatsby-link";
import { Box } from "rebass";
import * as Icon from "react-feather";
import Text from "./Text";
import H4 from "./Headings/H4";
import styled from "styled-components";

const Wrapper = styled(Box)`
  position: relative;
  display: block;
  background-color: ${(props) => props.theme.colors.grey[2]};
  border-bottom: 1px solid ${(props) => props.theme.colors.grey[1]};
  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  user-select: none;
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.grey[1]};
    .action-icon {
      opacity: 1;
    }
  }
  &:focus {
    z-index: 1;
    background-color: ${(props) => props.theme.colors.grey[1]};
    outline: 4px solid ${(props) => props.theme.colors.violet};
    box-shadow: none;
    .action-icon {
      opacity: 1;
    }
  }

  &:active {
    background-color: ${(props) =>
      props.theme.colors.grey[1] && rgba(props.theme.colors.grey[1], 0.5)};
    .action-icon {
      opacity: 0.5;
    }
  }
`;

Wrapper.defaultProps = {
  is: Link,
  to: "/",
  py: 3,
};

const Container = styled(Box)`
  position: relative;
`;

Container.defaultProps = {
  px: 3,
};

const IconContainer = styled(Box)`
  position: absolute;
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  opacity: 0.5;
  &:not(:lang(ar)) {
    left: 16px;
  }
  &:lang(ar) {
    right: 16px;
  }
`;

const TextResult = styled(Text)`
  width: 100%;
  padding-right: ${24 + 16}px;
  padding-left: ${24 + 16}px;
  ${ellipsis()};
`;

const ActionContainer = styled(Box)`
  position: absolute;
  top: 50%;
  width: 24px;
  height: 24px;
  opacity: 0;
  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);
  transform: translateY(-50%);
  &:not(:lang(ar)) {
    right: 16px;
  }
  &:lang(ar) {
    left: 16px;
  }
`;

const Metadata = styled(Box)`
  opacity: 0.5;
`;

Metadata.defaultProps = {
  px: 56,
  pt: 1,
};

const SearchResult = (props) => (
  <Wrapper
    to={"/" + props.result.url}
    onClick={props.result.url ? props.onClick : ""}
    is={
      props.result.url
        ? props.result.url.indexOf("http") !== -1
          ? "a"
          : Link
        : "div"
    }
    href={props.result.url}
    target={
      props.result.url
        ? props.result.url.indexOf("http") !== -1
          ? "_blank"
          : ""
        : ""
    }
    onKeyDown={props.onKeyDown}
    role="option"
    aria-labell={props.result.name}
    tabIndex={1}
  >
    <Container>
      <IconContainer>
        {props.result.type === "region" && (
          <Icon.Globe size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type.indexOf("• Document") !== -1 && (
          <Icon.Book size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type.indexOf("resource") !== -1 &&
          props.result.type.indexOf("• Audio") === -1 &&
          props.result.type.indexOf("• Video") === -1 &&
          props.result.type.indexOf("• Document") === -1 && (
            <Icon.Link size={24} strokeWidth={1.5} stroke="#363636" />
          )}
        {props.result.type.indexOf("• Audio") !== -1 && (
          <Icon.Volume2 size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type.indexOf("• Video") !== -1 && (
          <Icon.Video size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type === "update" && (
          <Icon.BookOpen size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type === "institution" && (
          <Icon.Briefcase size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type === "member" && (
          <Icon.User size={24} strokeWidth={1.5} stroke="#363636" />
        )}
        {props.result.type === "projec" && (
          <Icon.Flag size={24} strokeWidth={1.5} stroke="#363636" />
        )}
      </IconContainer>
      <TextResult
        children={
          props.result.type === "Algolia" ? (
            <img src="https://res.cloudinary.com/hilnmyskv/image/upload/q_auto/v1587462408/Algolia_com_Website_assets/images/shared/algolia_logo/search-by-algolia-light-background.svg" />
          ) : (
            props.result.name
          )
        }
        id={"result-label" + props.index}
        style={{ lineHeight: 1 }}
      />
    </Container>
    {props.result.type !== "Algolia" && props.result.type !== "noresults" && (
      <Metadata>
        <H4
          children={
            props.result.type === "projec"
              ? props.windowLang === "en-us"
                ? "project"
                : props.windowLang === "es-mx"
                ? "Proyecto"
                : "مشروع"
              : props.result.type === "member"
              ? props.windowLang === "en-us"
                ? "staff"
                : props.windowLang === "es-mx"
                ? "Equipo"
                : "الفريق"
              : props.result.type === "Algolia"
              ? ""
              : props.result.type === "region"
              ? props.windowLang === "en-us"
                ? "region"
                : props.windowLang === "es-mx"
                ? "regione"
                : "مشروع"
              : props.result.type === "institution"
              ? props.windowLang === "en-us"
                ? "institution"
                : props.windowLang === "es-mx"
                ? "Institucione"
                : "مؤسسات"
              : props.result.type === "team"
              ? props.windowLang === "en-us"
                ? "team"
                : props.windowLang === "es-mx"
                ? "Directorio del equipo"
                : "دليل فريق المركز"
              : props.result.type === "update"
              ? props.windowLang === "en-us"
                ? "update"
                : props.windowLang === "es-mx"
                ? "Noticia"
                : "تحديث"
              : props.result.type.indexOf("• Document")
              ? props.windowLang === "en-us"
                ? props.result.type
                : props.windowLang === "es-mx"
                ? "Documento"
                : "وثيقة"
              : props.result.type.indexOf("• Audio")
              ? props.windowLang === "en-us"
                ? props.result.type
                : props.windowLang === "es-mx"
                ? "audio"
                : "صوت"
              : props.result.type.indexOf("• Video")
              ? props.windowLang === "en-us"
                ? props.result.type
                : props.windowLang === "es-mx"
                ? "video"
                : "فيديو"
              : ""
          }
          is="div"
        />
      </Metadata>
    )}
    {props.result.type !== "" && props.result.type !== "Algolia" && (
      <ActionContainer className="action-icon">
        <Icon.ArrowRight size={24} strokeWidth={1.5} stroke="#363636" />
      </ActionContainer>
    )}
  </Wrapper>
);

SearchResult.defaultProps = {};

export default SearchResult;



// WEBPACK FOOTER //
// ./src/components/SearchResult.js